export * from './GeneralFaq'
export * from './RelatedFaq'
